import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {KTSVG} from '../../../../template/helpers'
import {clipboard} from '../../../../template/helpers/Clipboard'
import {appsAPI, ICdrStateResponse} from '../../../../services/AppsService'

const CallDetail = () => {
  const intl = useIntl()
  const {appId} = useParams()
  const [buffer, setBuffer] = useState(false)
  const {data: app} = appsAPI.useFetchAppByIdQuery(appId!)
  const [cdrState, updateCdrState] = useState(false)
  const [updateCdr, {isLoading}] = appsAPI.useUpdateCdrStateMutation()
  const [cdrActive, updateCdrActive] = useState(false)
  const [installStr, updateInstallStr] = useState<string | undefined>()
  const [showInfo, updateShowInfo] = useState<boolean>(false)

  useEffect(() => {
    if (app && app.extensions) {
      updateCdrActive(app.extensions.cdr)
    }
  }, [app])

  const copyBufer = (copyData: string) => {
    setBuffer(true)
    clipboard(copyData)
    setTimeout(() => {
      setBuffer(false)
    }, 600)
  }

  const handleSave = () => {
    if (cdrActive) {
      updateShowInfo(true)
    } else {
      updateShowInfo(false)
    }
    updateCdr({id: app?.id!, data: {is_active: cdrActive}})
      .unwrap()
      .then((response: ICdrStateResponse | void) => {
        if (response) {
          updateInstallStr(response.detail)
        }
      })
    updateCdrState(false)
  }

  const handleCancel = () => {
    if (app && app.extensions) {
      updateCdrActive(app!.extensions.cdr)
    }
    updateCdrState(false)
  }

  return (
    <>
      {!cdrState && (
        <div className='card card-custom card-stretch shadow-sm mb-5'>
          <div className='card-header'>
            <div className='card-title m-0'>
              <h3 className='fw-bolder m-0'>{intl.formatMessage({id: 'APPS.CDR'})}</h3>
            </div>
            <button className='btn btn-sm btn-primary align-self-center' onClick={() => updateCdrState(true)}>
              <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-info me-1 align-self-center' />
              {intl.formatMessage({id: 'BUTTON.EDIT'})}
            </button>
          </div>
          <div className='card-body pt-5 pb-5'>
            <div className='row d-flex align-items-center'>
              <label className='col-lg-4 fw-bolder text-gray-600 text-uppercase small'>
                {intl.formatMessage({id: 'APPS.CDR'})}
              </label>

              <div className='col-lg-8'>
                <span className='badge badge-light-info'>
                  {cdrActive
                    ? intl.formatMessage({id: 'APPS.CDR.STATUS.ACTIVE'})
                    : intl.formatMessage({id: 'APPS.CDR.STATUS.NOTACTIVE'})}
                </span>
              </div>
            </div>
            {showInfo && (
              <div className='alert alert-primary mt-4'>
                {intl.formatMessage({id: 'APPS.CDR.INSTALL.INFO'})}
                {isLoading ? (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    <span className='text-gray-600'>{intl.formatMessage({id: 'APPS.CDR.WAIT'})}</span>
                    <span className='spinner-border spinner-border-sm align-middle text-gray-600 ms-2' />
                  </span>
                ) : (
                  <>
                    {installStr && (
                      <div className=''>
                        <code
                          className={clsx('fs-9 px-0 mx-0 me-3', {'text-gray-700': !buffer}, {'text-info': buffer})}
                        >
                          {installStr.slice(0, -58)} ...
                        </code>
                        <button
                          onClick={() => copyBufer(installStr)}
                          className={clsx('btn btn-link text-gray-900 pt-0 pb-0', {'text-hover-primary': !buffer})}
                        >
                          {!buffer ? (
                            <KTSVG
                              path='/media/icons/duotune/general/gen054.svg'
                              className='svg-icon-gray-900 svg-icon m-0'
                            />
                          ) : (
                            <KTSVG path='/media/icons/duotune/arrows/arr012.svg' className='svg-icon-success m-0' />
                          )}
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      )}
      {cdrState && (
        <div className='card card-custom card-stretch shadow-sm mb-5'>
          <div className='card-header'>
            <div className='card-title m-0'>
              <h3 className='fw-bolder m-0'>{intl.formatMessage({id: 'APPS.CDR'})} </h3>
            </div>
          </div>
          <div className='card-body pt-5 pb-5'>
            <div className='row'>
              <label className='col-lg-4 col-form-label fw-bolder text-gray-600'>
                <span className='small text-uppercase'>{intl.formatMessage({id: 'APPS.CDR'})}</span>
              </label>

              <div className='col-lg-8 d-flex align-items-center'>
                <div className='form-check form-switch form-check-custom form-check-solid me-10'>
                  <input
                    className='form-check-input h-20px w-30px align-self-center'
                    type='checkbox'
                    onClick={() => {
                      updateCdrActive(!cdrActive)
                    }}
                    defaultChecked={cdrActive}
                  />
                </div>
              </div>
            </div>
            <div className='card-footer d-flex justify-content-end py-2 px-1' style={{border: 'none'}}>
              <button className='btn btn-sm btn-primary me-3' disabled={isLoading} onClick={handleSave}>
                {!isLoading && intl.formatMessage({id: 'BUTTON.SAVE'})}
                {isLoading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'WAIT'})}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <button className='btn btn-sm btn-light-primary align-self-center' onClick={handleCancel}>
                {intl.formatMessage({id: 'BUTTON.CANCEL'})}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export {CallDetail}
